// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p.title {
  color: #CCFF00;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/footer/footer.component.scss","webpack://./../../../=%3E%20finsuro/finsuro.mail/frontend/src/app/layout/footer/footer.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;ACDF","sourcesContent":["@import '../../../variables';\n\np.title {\n  color: $lemongreen\n}\n","p.title {\n  color: #CCFF00;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
